import { NextRouter } from 'next/router';
import { IInteriorDesignFilter, ITagArticles } from '@features/cms/typescript';
const setUrlParam = (router: NextRouter, activeTags?: ITagArticles[], page?: number, filters?: IInteriorDesignFilter[]) => {
  const {
    pathname,
    query
  } = router;
  const tags: string[] = [];
  const filtersParams: Record<string, string[]> = {};
  if (activeTags) activeTags.forEach(activeTag => tags.push(activeTag.name));
  if (filters && filters.length) {
    filters.forEach(filter => {
      if (!filtersParams[filter.type]) {
        filtersParams[filter.type] = [];
      }
      if (filter.isChecked && filter.type) {
        filtersParams[filter.type].push(filter.value);
      }
    });
  }
  if (page) {
    query.page = page.toString();
  }
  if (tags.length) {
    query.tags = tags.join('-');
  } else {
    delete query.tags;
  }
  Object.keys(filtersParams).forEach(filterType => {
    if (filtersParams[filterType].length) {
      query[filterType] = filtersParams[filterType].join('-');
    } else {
      delete query[filterType];
    }
  });
  void router.push({
    pathname,
    query
  }, undefined, {
    shallow: true
  });
  return;
};
export default setUrlParam;